<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Affiliate</p>
          <div>
            <el-tooltip content="Create" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click="setDialog(true)"
              ></el-button>
            </el-tooltip>
            <Dialog :active-tab="activeTab" />
            <DialogModel />
          </div>
        </div>
        <el-tabs type="border-card" v-model="activeTab">
          <el-tab-pane label="Creators" name="creators"> <Table /> </el-tab-pane>
          <el-tab-pane label="Artists" name="artists"> <ArtistTable /> </el-tab-pane>
          <el-tab-pane label="Labels" name="labels"> <LabelTable /> </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/affiliate/Table'
import ArtistTable from "@/modules/admin/cms/components/affiliate/ArtistTable";
import LabelTable from '@/modules/admin/cms/components/affiliate/LabelTable'
import Dialog from '../components/affiliate/Dialog'
import DialogModel from '../components/affiliate/DialogModel'
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      activeTab: 'creators'
    }
  },

  components: {
    Table,
    Dialog,
    DialogModel,
    ArtistTable,
    LabelTable
  },

  computed: {
    ...mapState('affiliate', ['loading'])
  },

  methods: {
    ...mapMutations('affiliate', ['setDialog'])
  }
}
</script>
